import { FC, useContext, useEffect, useState } from "react";
import {
  Button,
  CircularProgress,
  Collapse,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { PhysicalExaminationContext } from ".";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import AddPhysicalExamination from "./AddPhysicalExamination";
import CloseIcon from "@mui/icons-material/Close";
import { useMutation } from "react-query";
import {
  deleteFirstPhysicalExamination,
  getPhysicalExamination,
} from "../../services";
import { useParams } from "react-router-dom";
import usePopup from "../../../hooks/usePopup";
import EmptyListAlert from "../layouts/EmptyListAlert";
import HistoryComponent from "../layouts/HistoryComponent";
const PhysicalExaminationList: FC = () => {
  const { encounterId } = useParams();
  const {showSnackbar} = usePopup()
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState(-1);
  const { list, setEdit, edit, setList, refetch, setRefetch } = useContext(
    PhysicalExaminationContext
  );

  const { mutate: fetchList } = useMutation(getPhysicalExamination, {
    onSuccess: (result) => {
      setList(result.response);
      setRefetch(false);
    },
  });

  const { mutate: deletePhysicalExamination, isLoading: deleteLoading } =
    useMutation(deleteFirstPhysicalExamination,{
      onSuccess:(result)=>{
          if(result.responseIndicator == "success"){
            showSnackbar({
              message:result.responseMessage,
              open:true,
              variant:"success",
              duration:2000
            })
            setRefetch(true);
          }else{
            showSnackbar({
              message:result.responseMessage,
              open:true,
              variant:"warning",
              duration:2000
            })
          }
      },
      onError:()=>{
        showSnackbar({
          message:"Something went wrong !",
          open:true,
          variant:"warning",
          duration:2000
        })
      }
    });

  const handleClose = () => {
    setOpen(false);
    setEdit(null);
  };

  const handleDelete = (id: number, index: number) => {
    deletePhysicalExamination(id);
    setSelected(index);
  };

  useEffect(() => {
    if (refetch) {
      fetchList(encounterId as string);
    }
  }, [refetch]);

  return (
    <TableContainer component={Paper}>
      <Table size="small" sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead
          sx={(theme) => ({ backgroundColor: theme.palette.primary.main })}
        >
          <TableRow>
            {headings.map((heading: string, index: number) => (
              <TableCell
                sx={(theme) => ({ color: theme.palette.background.paper })}
                key={`tableHeading${index}`}
              >
                {heading}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell sx={{ padding: 0 }} colSpan={headings.length}>
               <EmptyListAlert alert="No physical examinations" isData={Boolean(list.length || open)}>
               <div className="flex flex-row justify-end  items-center p-2 gap-2">
                {!open && (
                  <Button
                    onClick={() => {
                      setOpen(true);
                      setEdit(null)
                    }}
                    color="success"
                    endIcon={<AddCircleIcon />}
                  >
                    add
                  </Button>
                )}
                <HistoryComponent title="Physical Examination"  tableprops={tableProps}/>
              </div>
               </EmptyListAlert>
              <Collapse in={open} className="relative">
                <AddPhysicalExamination close={handleClose} />
              </Collapse>
            </TableCell>
          </TableRow>
          {list.map((row, index) => (
            <>
              <TableRow
                key={`${index}tableRow`}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell component="th" scope="row">
                  {index + 1}
                </TableCell>
                <TableCell component="th" scope="row">
                  {row.description}
                </TableCell>
                
                {/* <TableCell>
                  {row. ? (
                    <Chip
                      size="small"
                      sx={{ width: 62 }}
                      label="Active"
                      color="success"
                    />
                  ) : (
                    <Chip
                      size="small"
                      sx={{ width: 62 }}
                      label="Inactive"
                      color="error"
                    />
                  )}
                </TableCell> */}
                <TableCell>
                  <span>
                    {edit?.id == row.id ? (
                      <IconButton
                        color="error"
                        onClick={() => {
                          setEdit(null);
                        }}
                      >
                        <CloseIcon />
                      </IconButton>
                    ) : (
                      <IconButton
                        onClick={() => {
                          setEdit(row);
                          setOpen(false)
                        }}
                        color="primary"
                      >
                        <EditIcon />
                      </IconButton>
                    )}
                    {(deleteLoading && selected == index) ? (
                      <CircularProgress color="error" size={18}/>
                    ) : (
                      <IconButton
                        color="error"
                        onClick={() => {
                          handleDelete(row.id, index);
                        }}
                      >
                        <DeleteIcon />
                      </IconButton>
                    )}
                  </span>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell sx={{ padding: 0 }} colSpan={headings.length}>
                  <Collapse in={Boolean(edit) && edit?.id == row.id}>
                    <AddPhysicalExamination close={handleClose} />
                  </Collapse>
                </TableCell>
              </TableRow>
            </>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default PhysicalExaminationList;
const headings = ["No.", "REMARKS", "OPTIONS"];

const tableProps = [
  { heading: "REMARKS", key: "description" },
  { heading: "createdDate", key: "createdDate" , date: "DD-MM-YYYY"},
  
]
